import React from "react";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { SectionHeading, Reveal } from "./ui";

const layers = [
  { layer: "Plan", handles: "Translate product roadmap and runway into role sequence, skills, seniority and workforce mix.", outcome: "Hire in the right order." },
  { layer: "Build", handles: "Source, screen and coordinate selection for technology and other approved role families.", outcome: "Reduce founder interview load." },
  { layer: "Activate", handles: "Coordinate documentation, onboarding, access and the first 30-day start plan.", outcome: "Get people productive faster." },
  { layer: "Operate", handles: "Manage agreed workforce cadence, partner coordination, backfills and ramp-up or ramp-down.", outcome: "Keep fixed overhead flexible." },
];

export default function StartupWorkforceHome() {
  return (
    <section className="section relative overflow-hidden bg-white">
      <div className="container-x grid gap-16 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <SectionHeading index="05" eyebrow="For tech startups" title="Build the team. Skip the workforce overhead." className="mb-8">
            Your startup needs the right people, but it may not need a full internal hiring and workforce
            function. Chiparama helps you plan roles, source and assess talent, coordinate onboarding, and
            manage a flexible workforce through one accountable partner.
          </SectionHeading>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link to="/startup-workforce" className="btn-primary group">
              Plan my startup workforce
              <HiArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </Link>
            <Link to="/startup-workforce" className="btn-secondary">See how it works</Link>
          </div>
        </div>

        <ol className="relative lg:col-span-7">
          <span className="absolute bottom-6 left-[1.4rem] top-6 w-px bg-gradient-to-b from-brand via-slate-200 to-transparent" aria-hidden="true" />
          {layers.map((item, i) => (
            <Reveal as="li" key={item.layer} delay={i * 90} className="relative pb-6 pl-16 last:pb-0">
              <span className="absolute left-0 top-1 flex h-11 w-11 items-center justify-center rounded-full border border-brand/30 bg-white font-mono text-xs text-brand shadow-sm">
                0{i + 1}
              </span>
              <div className="rounded-2xl border border-slate-200 bg-white p-7 transition duration-300 hover:-translate-y-0.5 hover:border-brand/40 hover:shadow-[0_24px_60px_-28px_rgba(36,87,245,0.35)]">
                <h3 className="font-display text-2xl font-semibold tracking-tight text-ink">{item.layer}</h3>
                <p className="mt-3 leading-relaxed text-slate-600">{item.handles}</p>
                <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-tint px-3.5 py-1.5 text-sm font-medium text-brand">
                  <span className="h-1.5 w-1.5 rounded-full bg-signal" aria-hidden="true" />
                  {item.outcome}
                </p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
